import _upperFirst from 'lodash/upperFirst';
import _toLower from 'lodash/toLower';
import { Task } from 'graphql-common';
import getFullName from '@lib/utils/getFullName';
import { Values, Value } from '@lib/interfaces/form';
import { AssignationsType, FieldNames } from 'routes/Task/enums';

export default function getTaskValuesFormFromQueryData(
  taskData: Task,
  isCreateForm?: boolean,
): Values {
  let siteArea: Value;
  if (taskData.siteArea) {
    const siteAreaOption = {
      label: taskData.siteArea.name,
      value: taskData.siteArea.id,
    };
    siteArea = isCreateForm ? [siteAreaOption] : siteAreaOption;
  }

  let asset: Value;
  if (taskData.asset) {
    const assetOption = {
      label: taskData.asset.name,
      value: taskData.asset.id,
      data: taskData.asset,
    };
    asset = isCreateForm ? [assetOption] : assetOption;
  }

  return {
    [FieldNames.assignations]: [
      {
        siteArea: taskData.siteArea?.id
          ? {
              label: taskData.siteArea.name,
              value: taskData.siteArea.id,
              data: taskData.siteArea,
            }
          : undefined,
        asset: taskData.asset?.id
          ? {
              label: taskData.asset.name,
              value: taskData.asset.id,
              data: taskData.asset,
            }
          : undefined,
      },
    ],
    [FieldNames.taskName]: taskData.name,
    [FieldNames.taskDescription]: taskData.description || '',
    [FieldNames.template]: taskData.formTemplate
      ? {
          value: taskData.formTemplate?.id,
          label: taskData.formTemplate?.name,
        }
      : undefined,
    [FieldNames.templateVersion]: taskData.formTemplateVersion
      ? {
          value: taskData.formTemplateVersion?.id,
          label: taskData.formTemplateVersion?.version,
        }
      : undefined,
    [FieldNames.priority]: taskData.priority
      ? {
          label: _upperFirst(_toLower(taskData.priority)),
          value: taskData.priority,
        }
      : undefined,
    [FieldNames.site]: taskData.site
      ? { label: taskData.site.name, value: taskData.site.id }
      : undefined,
    [FieldNames.assignationsType]: taskData.asset?.id
      ? { value: AssignationsType.Equipment }
      : { value: AssignationsType.Area },
    [FieldNames.siteArea]: siteArea,
    [FieldNames.asset]: asset,
    [FieldNames.approver]: taskData.approver
      ? {
          label: getFullName(taskData.approver),
          value: taskData.approver.id,
          data: taskData.approver,
        }
      : undefined,
    [FieldNames.sitesForApprover]:
      isCreateForm && taskData.site?.id
        ? [{ value: taskData.site.id }]
        : undefined,
    // Custom renders
    [FieldNames.assignationsTitle]: null,
    [FieldNames.taskDetails]: null,
    [FieldNames.templateTitle]: null,
    [FieldNames.templateVersionViewBtn]: null,
  };
}
